export default __webpack_public_path__ + "static/appstore-download-b882b1c7f6dcd9363602a4b88793e09d.svg";